import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import { usePraxis } from "../context/PraxisContext";

const mdComponents = {
  a: ({ node, ...props }) => (
    <a
      {...props}
      target={props.href?.startsWith("http") ? "_blank" : undefined}
      rel={props.href?.startsWith("http") ? "noopener noreferrer" : undefined}
    />
  ),
};

export default function Datenschutz() {
  const { effectiveDatenschutz } = usePraxis();
  return (
    <div className="legal-page" data-testid="datenschutz-page">
      <p className="section-label">Rechtliches</p>
      <h1>Datenschutzerklärung</h1>
      <div className="legal-md">
        <ReactMarkdown remarkPlugins={[remarkBreaks]} components={mdComponents}>
          {effectiveDatenschutz}
        </ReactMarkdown>
      </div>
    </div>
  );
}
